import { MAX_MT_ROW_COUNT } from "./settings.ts";

export const RowCountComponent = ({ rowCount }: { rowCount: number }) => {
  return (
    <div style={{ marginLeft: 5 }}>
      <span>Total rows:&nbsp;</span>
      <span className="ag-status-name-value-value">
        {rowCount.toLocaleString("en-US") + (rowCount === MAX_MT_ROW_COUNT ? "+" : "")}
      </span>
    </div>
  );
};
